import React, { useState } from "react";

import ProductMynavbar from "./ProductNavbar";
import { ENDPOINTS } from "../constants/endpoints";

export class ProductComposzNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      subscription_id: "",
      subscription_status: "",
      subscription_count: 0,
      subscription_type: "",
      additionalUsers: false,
      sub_avail_space: -1,
      part_of: ""
    };
    document.cookie = "cartCounter=25;";
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.getsubidfromDB();
    if (localStorage.getItem("PayPalPayment")) {
      let msg = localStorage.getItem("PayPalPaymentMsg");
      localStorage.removeItem("PayPalPayment");
      localStorage.removeItem("PayPalPaymentMsg");
      alert(`${msg}`);
      //alert("Payment done Successfully\n");
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  getsubidfromDB = () => {
    let subid_uri = ENDPOINTS.subid.index.uri;
    let noRecords;

    const handleLogout = () => {
      const link = document.createElement("a");
      link.setAttribute("href", "/users/sign_out");
      link.setAttribute("rel", "nofollow");
      link.setAttribute("data-method", "delete");
      document.body.appendChild(link);
      link.click();
    };

    (async () => {
      noRecords = await fetch(subid_uri, {
        method: "GET",
        headers: { "content-type": "application/json" }
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            subscription_id: data.sub_id,
            subscription_status: data.sub_status,
            subscription_count: data.sub_count,
            subscription_type: data.sub_type,
            additionalUsers: data.sub_count > 0 ? true : false,
            sub_avail_space: data.sub_avail_space,
            part_of: data.part_of
          });
          if (data.sub_status === "SUSPENDED") {
            alert(
              "ATTENTION: Subscription 'Terms & Conditions' VIOLATION detected/suspected!\nYour Subscription Account has been Suspended\nContact 'Composz support team' immediately to remedy the situation by sending an email to 'composz-team@composz.com'"
            );
            handleLogout();
          }
        });
    })();
  };

  handleResize = (e) => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    this.setState((prevState) => {
      return {
        windowWidth,
        windowHeight
      };
    });
  };

  Fnavbar = () => {
    let Usernavbar = ProductMynavbar(
      this.props.user_id,
      this.props.user_name,
      this.props.user_email,
      this.props.has_view_products,
      this.state.subscription_id,
      this.state.subscription_status,
      this.state.subscription_count,
      this.state.subscription_type,
      this.state.additionalUsers,
      this.state.sub_avail_space,
      this.state.part_of
    );
    return Usernavbar;
  };

  render() {
    return (
      <React.Fragment>
        <this.Fnavbar />
      </React.Fragment>
    );
  }
}

export default ProductComposzNavbar;
